// Global animation timing — adjust SPEED to scale durations and delays together.
export const ANIMATION_SPEED = 1.5;

export const DURATION = 1 * ANIMATION_SPEED;
export const STAGGER = 0.08 * ANIMATION_SPEED;
export const TEXT_DELAY = 0.15 * ANIMATION_SPEED;
export const FOOTER_DELAY = 0.25 * ANIMATION_SPEED;
export const MASK_SPLIT_DURATION = 1.3 * ANIMATION_SPEED;
export const TEXT_STAGGER = 0.08 * ANIMATION_SPEED;
export const PANEL_DURATION = 0.45 * ANIMATION_SPEED;
export const REVEAL_DURATION = 1 * ANIMATION_SPEED;
export const SCROLL_TO_DURATION = 1;
export const HERO_DELAY = 0.2 * ANIMATION_SPEED;
export const FACTS_ANIMATION_MS = 1800 * ANIMATION_SPEED;

export const EASE = "power4.out";
export const EASE_PANEL = "power3.out";
